/**
 * The avatar catalogue.
 *
 * Lives in shared, not on the server, because the profile picker has to offer
 * exactly the set the server will accept — a second list on the client is a
 * validation error waiting to happen.
 */
export const AVATARS = [
  '🦊',
  '🐼',
  '🐨',
  '🐯',
  '🦁',
  '🐸',
  '🐙',
  '🦉',
  '🐝',
  '🦄',
  '🐧',
  '🐳',
  '🦋',
  '🐢',
  '🦔',
  '🐿️',
  '🦆',
  '🦩',
  '🐬',
  '🦜',
  '🐴',
  '🐮',
  '🐷',
  '🐰',
  '🐱',
  '🐶',
  '🦖',
  '🦕',
  '🐲',
  '🦈',
] as const;

export type Avatar = (typeof AVATARS)[number];

export function isAvatar(value: string): value is Avatar {
  return (AVATARS as readonly string[]).includes(value);
}
